import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let payment_account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'payor',
    path: 'payment_account_id',
  })

  return {
    variables: {
      payment_account_id,
    },
  }
}
